<template lang="pug">
  v-row
    v-col(cols=12 md=6)
      .title Темы
      v-sheet.units-column
        v-skeleton-loader(
          v-if="loading.units"
          type="list-item@3"
        )
        v-list(v-else)
          v-list-item(v-if="!units.items.length")
            v-list-item-subtitle Темы не добавлены
          v-list-item(
            v-for="(unit, idx) in units.items"
            :key="idx"
            :class="{ 'sdo-active-dark': units.selected === unit }"
            @click="units.selected = unit; lessons.selected = null"
          )
            v-list-item-avatar
              v-avatar(
                color="secondary"
              )
                strong.white--text {{ idx + 1 }}
            v-list-item-content
              v-list-item-title.pre-wrap
                span {{ unit.title }}
              v-list-item-subtitle
                span Уроков - {{ unit.lessons.length }}
      div(v-if="units.selected")
        .title Уроки
        v-sheet(ref="lessons").units-column
          v-list
            v-list-item(
              v-if="!units.selected.lessons.length"
            )
              v-list-item-content
                v-list-item-subtitle В теме нет уроков...
            v-list-item(
              v-for="(lesson, idx) in units.selected.lessons"
              :key="idx"
              :class="{ 'sdo-active-dark': lessons.selected === lesson }"
              @click="lessons.selected = lesson"
            )
              v-list-item-avatar
                v-avatar(
                  color="secondary"
                )
                  strong.white--text {{ idx + 1 }}
              v-list-item-content
                v-list-item-title.pre-wrap {{ lesson.name }}
                v-list-item-subtitle
                  span Заданий - {{ lesson.tasks.length }}
    v-col(
      cols=12 md=6
    )
      v-slide-y-reverse-transition
        tasks-progress(
          v-if="subject"
          :subject="subject"
          flat
        ).px-5
</template>

<script>
import TasksProgress from '@/modules/Education/Teach/components/TasksBySubject.vue';

export default {
  components: {
    TasksProgress,
  },
  props: {
    // Instance Module.js
    moduleItem: { type: Object, required: true },
  },
  data: () => ({
    units: {
      selected: null,
      items: [],
    },
    lessons: {
      selected: null,
      items: [],
    },
    loading: {
      units: false,
    },
  }),
  computed: {
    subject() {
      return this.lessons.selected || this.units.selected;
    },
  },
  created() {
    this.fetchUnits();
  },
  methods: {
    async fetchUnits() {
      this.loading.units = true;
      const { items } = await this.$api.modules.courseUnits(this.moduleItem.id, {
        expand: 'lessons,tasks',
      });
      this.units.items = items;
      this.loading.units = false;
    },
  },
};
</script>
